import PropTypes from "prop-types";

// @mui material components
import FilledInput from "@mui/material/FilledInput";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";

/**
 * MUI v5 white filled input used on the full-page login screens.
 * Keeps the v1 props: labelText, id, error, success, helperText,
 * formControlProps and inputProps (spread on the FilledInput).
 */
export default function CustomFilledInput({
	formControlProps,
	labelText,
	id,
	labelProps,
	inputProps,
	error = false,
	success = false,
	helperText
}) {
	const stateColor = error ? "#f44336" : success ? "#4caf50" : null;
	return (
		<FormControl
			variant="filled"
			{...formControlProps}
			error={error}
			sx={{ mb: "17px", ...formControlProps?.sx }}
		>
			{labelText !== undefined && (
				<InputLabel
					htmlFor={id}
					{...labelProps}
					sx={{
						fontSize: "14px",
						color: `${stateColor || "#495057"} !important`
					}}
				>
					{labelText}
				</InputLabel>
			)}
			<FilledInput
				id={id}
				{...inputProps}
				sx={{
					backgroundColor: "#ffffff",
					fontSize: "14px",
					"&:hover, &.Mui-focused, &.Mui-disabled": {
						backgroundColor: "#ffffff"
					},
					"&:before, &:hover:not(.Mui-disabled):before": {
						borderBottom: "1px solid #D2D2D2"
					},
					"&:after": {
						borderBottomColor: stateColor || "#49accd"
					},
					"& .MuiInputAdornment-root, & .material-icons-outlined, & svg": {
						color: "#495057",
						fontSize: "1.25rem !important"
					},
					...inputProps?.sx
				}}
			/>
			{helperText !== undefined && (
				<FormHelperText
					id={`${id}-text`}
					sx={{ fontWeight: 300, color: stateColor || undefined }}
				>
					{helperText}
				</FormHelperText>
			)}
		</FormControl>
	);
}

CustomFilledInput.propTypes = {
	labelText: PropTypes.node,
	labelProps: PropTypes.object,
	id: PropTypes.string,
	inputProps: PropTypes.object,
	formControlProps: PropTypes.object,
	error: PropTypes.bool,
	success: PropTypes.bool,
	helperText: PropTypes.node
};
